/**
 * @generated SignedSource<<3f4aa7095b2166bf3cc4ecca2b699e08>>
 * @relayHash 8c9809be84894c117d2ddef16ebdc0d3
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/klarnaUpdateSessionMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type ShipmentType = "EXTERNALLY_ARRANGED" | "FIRSTDIBS_FACILITATED" | "LOCAL_PICKUP" | "%future added value";
export type TransactionType = "NEGOTIABLE" | "NON_NEGOTIABLE" | "OFF_PLATFORM" | "PRE_AUTH_NEGOTIATION" | "%future added value";
export type UpdateKlarnaSessionInput = {
  billingAddress?: AddressInput | null;
  buyerChargeCurrency?: Currency | null;
  buyerId?: string | null;
  clientMutationId?: string | null;
  country?: string | null;
  currencyConversionRateEventId?: string | null;
  isTaxExempt?: boolean | null;
  itemId: string;
  klarnaSessionId: string;
  offerAmountPerItem?: number | null;
  offerCurrency?: Currency | null;
  promoCode?: string | null;
  quantity?: number | null;
  shipmentQuoteId?: string | null;
  shipmentType?: ShipmentType | null;
  shippingAddressId?: string | null;
  transactionId?: string | null;
  transactionType: TransactionType;
  zipCode?: string | null;
};
export type AddressInput = {
  active?: boolean | null;
  addressBookMember?: boolean | null;
  city?: string | null;
  company?: string | null;
  contact?: string | null;
  country?: string | null;
  firstName?: string | null;
  label?: string | null;
  lastName?: string | null;
  line1?: string | null;
  line2?: string | null;
  phoneNumber?: string | null;
  state?: string | null;
  zipCode?: string | null;
};
export type klarnaUpdateSessionMutation$variables = {
  input: UpdateKlarnaSessionInput;
};
export type klarnaUpdateSessionMutation$data = {
  readonly updateKlarnaSession: {
    readonly klarnaClientToken: string | null;
    readonly klarnaSessionId: string | null;
  } | null;
};
export type klarnaUpdateSessionMutation = {
  response: klarnaUpdateSessionMutation$data;
  variables: klarnaUpdateSessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateKlarnaSessionPayload",
    "kind": "LinkedField",
    "name": "updateKlarnaSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "klarnaSessionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "klarnaClientToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "klarnaUpdateSessionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "klarnaUpdateSessionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/klarnaUpdateSessionMutation",
    "metadata": {},
    "name": "klarnaUpdateSessionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "25199eaa01c8306b1056f739870d62f9";

export default node;
